import { graphql } from "../../generated";

export const approveCampaignMutation = graphql(/* GraphQL */ `
    mutation ApproveCampaign($campaignId: String!) {
        approveCampaign(campaignId: $campaignId) {
            id
        }
    }
`);
